<template>
  <div>
    <ValidationObserver slim v-slot="{ handleSubmit }">
      <v-card >
        <v-card-text>
          <v-container>
            <h1 class="mb-5 white--text">DATOS GENERALES</h1>
            <v-row>
              <v-col cols="12" md="4">
                <validation-provider
                  name="Nombre"
                  rules="required|max:45"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    :error-messages="errors"
                    label="Nombre"
                    v-model="nombre"
                    class="my-mayus"
                    maxlength="45"
                    counter="45"
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  name="Primer apellido"
                  :rules="{
                    required: validarMaterno,
                    max: validarMaterno ? { length: 45 } : false,
                  }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    :error-messages="errors"
                    label="Primer apellido"
                    v-model="paterno"
                    class="my-mayus"
                    maxlength="45"
                    counter="45"
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  name="Segundo apellido"
                  :rules="{
                    required: validarPaterno,
                    max: validarPaterno ? { length: 45 } : false,
                  }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    :error-messages="errors"
                    label="Segundo apellido"
                    v-model="materno"
                    class="my-mayus"
                    maxlength="45"
                    counter="45"
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <validation-provider
                  name="Tipo"
                  rules="required"
                  v-slot="{ errors }"
                >
                <v-radio-group v-model="mexicano" row  :error-messages="errors">
                  <v-radio label="MEXICANO" :value="1"></v-radio>
                  <v-radio label="EXTRANJERO" :value="0" @change="nacionalidad=[]" ></v-radio>
                </v-radio-group>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  name="CURP"
                  :rules="{
                    required: validarMexicano,
                    min: validarMexicano ? { length: 18 } : false,
                  }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    label="CURP"
                    v-model="curp"
                    :error-messages="errors"
                    prepend-icon="mdi-help-circle"
                    @click:prepend="abrirCurp"
                    v-mask="'AAAA######XXXXXXXX'"
                    counter
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  name="Sexo"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label>Sexo</label>
                  <v-radio-group v-model="sexo" row class="pt-0 mt-0"  :error-messages="errors"  >
                    <v-radio label="MASCULINO" value="M" ></v-radio>
                    <v-radio label="FEMENINO" value="F" ></v-radio>
                  </v-radio-group>
                   </validation-provider>
                
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                  
                <v-menu
                  ref="ref_menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  
                >
                  <template v-slot:activator="{ on, attrs }">
                    <validation-provider
                      name="Fecha de nacimiento"
                      rules="required"
                      v-slot="{ errors }"
                    >
                    <v-text-field
                      label="Fecha de nacimiento"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      v-model="fecha_nacimiento"
                      :error-messages="errors"
                     filled
                    >
                    </v-text-field>
                    </validation-provider>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="fecha_nacimiento"
                    :active-picker.sync="activePicker"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1950-01-01"
                    no-title
                    scrollable
                    color="primary"
                    @change="saveDay"
                    
                  >
                  </v-date-picker>
                </v-menu>
                
                
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  name="Nacionalidad"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    v-model="nacionalidad"
                    label="Nacionalidad(es)"
                    :items="lst_nacionalidades"
                    item-value="id_nacionalidad"
                    item-text="nombre"
                    multiple
                    :error-messages="errors"
                    :loading="loading_nacionalidades"   
                    filled                 
                  ></v-select>
                </validation-provider>
              </v-col>
            </v-row>
            <v-divider class="mt-5"></v-divider>

            <h1 class="mt-10 mb-5 white--text">ESCUELA DE PROCEDENCIA</h1>
            <v-row>
              <v-col cols="12" md="8">
                <validation-provider
                  name="Escuela Procedencia"
                  rules="required|max:45"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    label="Escuela de procedencia"
                    v-model="escuela_procedencia"
                    :error-messages="errors"
                    class="my-mayus"
                    counter="45" 
                    maxlength="45"
                    filled
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  name="Ubicacion de Escuela Procedencia"
                  rules="required|max:45"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    label="Ciudad/Estado/País de escuela de procedencia"
                    v-model="lugar_escuela_procedencia"
                    prepend-inner-icon="mdi-map-marker"
                    :error-messages="errors"
                    class="my-mayus"
                    counter="45" 
                    maxlength="45"
                    filled
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="mobil-botones">
          <v-spacer></v-spacer>
          <v-btn dark :disabled="loading" class="mr-3 px-4" color="errorxxx" style="background: linear-gradient(0deg, rgba(241,37,53,1) 0%, rgba(255,105,105,1) 100%)" @click="dialogSalir = true" rounded large>
            <v-icon class="mr-2">mdi-close-box-outline</v-icon>SALIR
          </v-btn>
          <v-btn
        
            color="secondaryx"
            class="black--text px-4"
            :loading="loading"
            @click="handleSubmit(saveorUpdate)"
            rounded
            large
            style="background: linear-gradient(0deg, rgba(255,182,0,1) 0%, rgba(255,219,130,1) 100%)"
          >
            <v-icon class="mr-2">mdi-content-save</v-icon>CONTINUAR Y GUARDAR
          </v-btn>

        </v-card-actions>
      </v-card>
    </ValidationObserver>

    <!-- REGISTRO CREADO -->
    <v-dialog v-model="dialog" width="450" persistent>
      <v-card>
        <v-card-text class="pt-5 pb-0">
          <h3 class="black--text">
            <v-icon large>mdi-information</v-icon>
            Registro actualizado con éxito
          </h3>
          <div class="mt-5">
            <p class="text-justify">
              Tu información del <b>paso 1</b> ha sido guardada.
            </p>
            <p class="text-justify">Clic en [ACEPTAR] para continuar.</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="bachillerato"
            dark
            @click="$emit('emit-next', 2), (dialog = false)"
          >
            <v-icon>mdi-check</v-icon>
            ACEPTAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / REGISTRO CREADO -->
    <!-- SALIR -->
    <v-dialog v-model="dialogSalir" width="450" persistent>
      <v-card>
        <v-card-text class="pt-5 pb-0">
          <h3 class="black--text">
            <v-icon large>mdi-information</v-icon>
            Salir
          </h3>
          <div class="mt-5">
            <p class="text-justify">
              ¿Esta seguro de <b>no continuar</b> con la captura?
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="error" dark @click="dialogSalir = false">
            <v-icon>mdi-close-box-outline</v-icon>
            NO
          </v-btn>
          <v-btn
            class="bachillerato"
            dark
            @click="$emit('emit-salir'), (dialogSalir = false)"
          >
            <v-icon>mdi-check</v-icon>
            SÍ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / SALIR -->
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch ,getCurrentInstance} from "vue";
import axios from "axios";
// import { mask } from "vue-the-mask";
import isNull from "lodash/isNull";

const root=getCurrentInstance()?.proxy

    let id_precaptura = root.$ls.get("id", 0); // Get session storage
    let id_aspirante = 0; //no se usa en el template
    const nombre = ref("");
    const paterno = ref("");
    const materno = ref("");
    const mexicano = ref(1);
    const curp = ref("");
    const sexo = ref();
    const fecha_nacimiento = ref();
    const nacionalidad = ref([112]); // 112 = Mexicano
    const escuela_procedencia = ref("");
    const lugar_escuela_procedencia = ref("");
    const lst_nacionalidades = ref([]);
    const dialog = ref(false);
    const dialogSalir = ref(false);
    const menu = ref(false);
    const loading=ref(false);
    const loading_nacionalidades=ref(false)

    const activePicker=ref(null)

    const validarPaterno = computed(() => paterno.value === "");
    const validarMaterno = computed(() => materno.value === "");
    const validarMexicano = computed(() => mexicano.value === 1);

    watch(menu, val => {
      // if (val) context.refs.picker.activePicker = "YEAR";
      if (val) activePicker.value = "YEAR";
    });
    watch(curp, val => {
      curp.value = curp.value.toUpperCase();
    });
    watch(mexicano, () => {
      mexicano.value === 0 ? (curp.value = "") : (nacionalidad.value = [112]);
    });

    onMounted(() => {
      getNacionalidades();
      if (root.$ls.get("paso", 0) > 0) getDatosAspirante();
    });

    //segun el id aspirante ejecuta un update o un insert
    async function saveorUpdate() {
      if(sexo.value!=""){

     
          let dataSend = {
            id_precaptura,
            nombre: nombre.value,
            primer_apellido: paterno.value,
            segundo_apellido: materno.value,
            mexicano: mexicano.value,
            curp: curp.value,
            sexo: sexo.value,
            fecha_nacimiento: fecha_nacimiento.value,
            nacionalidad: nacionalidad.value,
            escuela_procedencia: escuela_procedencia.value,
            lugar_escuela_procedencia: lugar_escuela_procedencia.value
          };
          loading.value=true;
          if (id_aspirante===0)await saveAspirante(dataSend); 
          else await updateAspirante(dataSend);
          loading.value=false
       }
    }

    async function getDatosAspirante() {
      root.$Progress.start()
      let { data, status } = await axios.get(
        `precaptura/aspirante/${id_precaptura}`
      );
      if (status === 200) {
        if(isNull(data.id_aspirante)){
          return;
          
        }
        id_aspirante = data.id_aspirante;
        nombre.value = data.nombre;
        paterno.value = data.primer_apellido;
        materno.value = data.segundo_apellido;
        mexicano.value = parseInt(data.mexicano);
        curp.value = data.curp;
        sexo.value = data.sexo;
        fecha_nacimiento.value = data.fecha_nacimiento;
        nacionalidad.value = data.nacionalidad.split(',').map(i=>parseInt(i));
        escuela_procedencia.value = data.escuela_procedencia;
        lugar_escuela_procedencia.value = data.lugar_escuela_procedencia;
      }
      root.$Progress.finish()
    }

    function saveDay(date) {
      refs.ref_menu.save(date);
    }

    async function saveAspirante(dataSend) {
      try {
        let { data, status } = await axios.post("precaptura/aspirante",dataSend);
        if (status === 201 && data > 0){
            id_aspirante=data;
            dialog.value = true;
            root.$ls.set("paso", 2)
        } 
      } catch (error) {
        console.error(error);
      }
    }

    async function updateAspirante(dataSend) { 
      try {
        let { data, status } = await axios.put(
          `precaptura/aspirante/${id_aspirante}`,
          dataSend
        );
        if (status === 200 && data > 0) dialog.value = true;
      } catch (error) {
        console.error(error);
      }
    }

    async function getNacionalidades() {
      loading_nacionalidades.value=true
      try {
        let { data, status } = await axios.get("nacionalidades");
        if (status === 200) lst_nacionalidades.value = data;
      } catch (error) {
        console.log(error);
      }finally{
        loading_nacionalidades.value=false
      }
    }

    function abrirCurp() {
      window.open("https://www.gob.mx/curp/");
    }

</script>
<style scoped>
@media (max-width: 600px) {
.mobil-botones{
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.mobil-botones button{
  width: 100%;
  margin-left: 0!important;
  margin-right: 0!important;
}
}
</style>